import { Divider, Form, Select, DatePicker, Input, InputNumber } from "antd";
import CustomerForm from "./customerForm";
import React from "react";

export default ({ form ,surgeryTypes}) => {
  return [
    // ---- Үйлчлүүлэгчийн мэдээлэл (Customer) ----
    {
      type: "component",
      component: (
        <Divider className="col-span-12" style={{ marginTop: 0 }}>
          Үйлчлүүлэгчийн мэдээлэл
        </Divider>
      ),
    },
    {
      type: "component",
      component: <CustomerForm form={form} />, // энэ нь { customer: {...} } талбаруудыг populate хийдэг гэж үзэж байна
    },

    // ---- Хэвтэлтийн мэдээлэл (Wound Patient) ----
    {
      type: "component",
      component: <Divider className="col-span-12">Хэвтэлтийн мэдээлэл</Divider>,
    },

    // Patient.type
    {
      label: "Төрөл",
      name: ["patient", "type"],
      type: "select",
      rules: [{ required: true, message: "Төрөл сонгоно уу!" }],
      className: "col-span-12 md:col-span-3 mb-0",
      inputProps: {
        className: "w-full",
        options: [
          { label: "Хэвтэн", value: "Хэвтэн" },
          { label: "Амбулатори", value: "Амбулатори" },
        ],
      },
    },
    // Patient.admissionDate
    {
      label: "Хэвтсэн огноо",
      name: ["patient", "admissionDate"],
      type: "date",
      rules: [{ required: true, message: "Хэвтсэн огноо оруулна уу!" }],
      className: "col-span-6 md:col-span-3 mb-0",
      inputProps: { className: "w-full" },
    },

    // Patient.surgeryDate
    {
      label: "Мэс засал хийсэн огноо",
      name: ["patient", "surgeryDate"],
      type: "date",
      className: "col-span-6 md:col-span-3 mb-0",
      inputProps: { className: "w-full" },
    },
    {
      label: "Хагалгааны төрөл",
      name: ["patient", "surgeryTypeId"],
      type: "select",
      className: "col-span-6 md:col-span-3 mb-0",
      inputProps: {
        className: "w-full",
        options:surgeryTypes
      },
    },
    // Patient.diagnosis
    {
      label: "Онош",
      name: ["patient", "diagnosis"],
      type: "input",
      className: "col-span-6 md:col-span-3 mb-0",
      inputProps: { className: "w-full" },
    },
    // Patient.diagnosis
    {
      label: "Гуурсны тоо",
      name: ["patient", "drainCount"],
      type: "number",
      className: "col-span-6 md:col-span-3 mb-0",
      inputProps: { className: "w-full" },
    },

    // Patient.note
    {
      label: "Тэмдэглэл",
      name: ["patient", "note"],
      type: "textarea",
      className: "col-span-12 md:col-span-12 mb-0",
      inputProps: { className: "w-full", rows: 3 },
    },
  ];
};
